import { LiveStreamSendItemApi } from '../../generated/api';
import configuration from './configuration';

export const liveStreamSendItemService = new LiveStreamSendItemApi(
  configuration,
);
